import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const KEY = "etq_cookie_consent";
const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST;

export function getConsent() { return localStorage.getItem(KEY); }

function loadAnalytics() {
  if (!POSTHOG_KEY || !POSTHOG_HOST || window.__etqAnalytics) return;
  window.__etqAnalytics = true;
  import("posthog-js").then((m) => { m.default.init(POSTHOG_KEY, { api_host: POSTHOG_HOST, person_profiles: "identified_only", capture_pageview: true }); }).catch(() => {});
}

export function CookieConsent() {
  const [choice, setChoice] = useState(getConsent());
  useEffect(() => { if (choice === "all") loadAnalytics(); }, [choice]);
  if (choice) return null;
  const pick = (v) => { localStorage.setItem(KEY, v); setChoice(v); };
  return (
    <div role="dialog" aria-label="Cookie choices" data-testid="cookie-banner" style={{ position: "fixed", left: 16, right: 16, bottom: 16, zIndex: 60, maxWidth: 560, margin: "0 auto", background: "var(--panel)", border: "1px solid var(--line)", borderRadius: 12, padding: "14px 16px", boxShadow: "0 12px 40px rgba(0,0,0,.45)", fontSize: ".84rem" }}>
      <b>Cookies.</b> We only use strictly necessary cookies (your sign-in session) by default. Optional analytics help us improve the product and load only if you allow them. <Link to="/legal/cookies" data-testid="cookie-policy-link">Cookie Policy</Link>
      <div className="flex gap-2 mt-3">
        <button className="btn sm" onClick={() => pick("essential")} data-testid="cookie-essential-btn">Essential only</button>
        {POSTHOG_KEY && <button className="btn sm ghost" onClick={() => pick("all")} data-testid="cookie-accept-btn">Allow analytics</button>}
      </div>
    </div>
  );
}
